<template>
  <div>
    <div class="wrap finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약하기</h3>
      </div>
      <div class="body-wrap">
        <img src="@/assets/img/finish-check.svg" alt="완료" />
        <h3>예약 요청이 완료되었습니다!</h3>
        <h4>
          코치님이 예약 확인 후 <br />
          코칭이 확정됩니다.
        </h4>
      </div>
      <div class="bnb-btn">
        <button class="active" @click="next()">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "reserve_finish",
  data: () => ({
    current_slide: 0,
  }),
  components: {
    incBack,
  },
  mounted() {},
  methods: {
    next() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
        courseIdx: this.$store.state.userInfo.courseIdx,
      };
      this.axios
        .get("/front/find/coarchingidx", { params })
        .then((res) => {
          let tempCoarching = res.data.data;
          this.currentCoarching = tempCoarching[0].coarchingIdx;
          this.$store.commit("setCurrentCoaching", this.currentCoarching);
          this.$store.commit("setpageFunc", "0");
          this.$store.commit("setIsReRcom", "0");
          this.$store.commit("setIsReCoach", "0");
          location.href = "/reservation_coaching";
        })
        .catch((err) => {
          location.href = "/reservation_coaching";
          console.log(err);
        });
    },
  },
};
</script>
